export const TAB_HISTORY_MAX_COUNT = 30;
